var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n\t"+_vm._s(_vm.item.name)+"\n\t"),(_vm.item.assignmentsCount > 0)?_c('a',{on:{"click":function($event){$event.preventDefault();return _vm.onClick.apply(null, arguments)}}},[_vm._v("\n\t\t"+_vm._s(_vm.item.assignmentsCount)+"\n\t")]):_c('span',[_vm._v(_vm._s(_vm.item.assignmentsCount))])])
}
var staticRenderFns = []

export { render, staticRenderFns }